/**
 * Handle padding the passed in number to the specified number of places.
 *
 * @example `zeroPad(104, 4)` will result in '0104'.
 *
 * @param num The number we wish to pad.
 * @param places The number of places to ensure is padded in the number.
 *
 * @returns The padded number as a string.
 */
export const zeroPad = (num: number, places: number): string => {
  return String(num).padStart(places, '0');
};

/**
 * Handle capitalising the first letter of each word in the provided string.
 * A custom delimeter may be provided.
 *
 * @param str The string we wish to capitalise.
 * @param delimeter The custom delimeter. Defaults to using a space.
 *
 * @returns The word capitalised string.
 */
export function cap(str: string, delimeter = ' '): string {
  return str
    .split(delimeter)
    .map((val) => val.charAt(0).toUpperCase() + val.substring(1).toLowerCase())
    .join(' ');
}

/**
 * Handle converting a string into a slugged version.
 *
 * @param str the string to convert.
 *
 * @returns the slugified string (e.g. `some-slug-string`)
 */
export function slugify(str: string): string {
  return str.toLowerCase().replace(/\s\s+/g, ' ').replaceAll(' ', '-');
}

/**
 * Handle providing the correct string for the unit of measure.
 *
 * @param unitOfMeasure the unit of measure to place in the string.
 * @param quantity the quantity that will be adjacent to the unit of measure.
 *
 * @returns the unit of measure for the quantity provided.
 */
export function uom(unitOfMeasure: string, quantity: number) {
  return quantity !== 1 ? `${unitOfMeasure}s` : unitOfMeasure;
}
